<template>
  <section id="cart">
    <next-prev-menu
      :previous="false"
      :title="nextStep.title"
      @next-step="$router.push({ name: nextStep.name })"
    ></next-prev-menu>
    <div class="cart-container card">
      <div class="title-container">
        <h3>Winkelwagen</h3>
      </div>

      <ul class="print-file-list">
        <file
          v-for="file in productList"
          :key="file.fileName"
          :file="file"
          @no-product="$emit('go-to-step', 'step1')"
          :editable="true"
          :deleteable="true"
          @remove="removeFile"
          :open="false"
        ></file>

        <print-store-product
          v-for="(product, index) in printStoreProducts"
          :key="index"
          :product="product"
          :editable="true"
          @set-quantity="setPrintStoreQuantity($event, index)"
          @remove="removeProduct"
        ></print-store-product>
      </ul>
    </div>
  </section>
</template>

<script>
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import { sortBy } from 'lodash-es/collection'
import File from './File.vue'
import PrintStoreProduct from './PrintStoreProduct.vue'
import cloneDeep from 'lodash-es/cloneDeep'
import { useFileListStore } from '@/stores/FileList.store'
import { storeToRefs } from 'pinia'
import { mapStores } from 'pinia'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  components: { NextPrevMenu, File, PrintStoreProduct },
  data() {
    return {}
  },
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    printStoreProducts() {
      return sortBy(this.printStoreStore.orderDetails.cart, ['fileName'])
    },
    ...mapStores(useCheckOutStore, useFileListStore, usePrintStoreStore),
    productList() {
      return this.checkOutStore.products
    },
    nextStep() {
      if (
        (this.custom.hideDeliverOptions ||
          this.checkOutStore.deliveryAddressIncludedInFiles) &&
        !this.custom.hideInvoiceOptions
      ) {
        return { name: 'checkOutInvoice', title: 'Naar Factureren' }
      } else if (
        (this.custom.hideDeliverOptions && this.custom.hideInvoiceOptions) ||
        (this.checkOutStore.deliveryAddressIncludedInFiles &&
          this.custom.hideInvoiceOptions)
      ) {
        return { name: 'checkOutConfirm', title: 'Naar Controleren' }
      } else {
        return { name: 'checkOutDeliver', title: 'Naar Bezorgen' }
      }
    }
  },
  methods: {
    removeFile(filId) {
      this.fileListStore.removeFile(filId)
      this.checkOutStore.removeFile(filId)
      this.homeRedirect()
    },
    removeProduct(product) {
      this.printStoreStore.removeFromCart(product)
      this.homeRedirect()
    },
    setPrintStoreQuantity(val, index) {
      let newProducts = cloneDeep(this.printStoreProducts)
      newProducts[index].quantity = val

      this.printStoreStore.updateCart(newProducts)
    },
    homeRedirect() {
      if (
        this.productList.length === 0 &&
        this.printStoreProducts.length === 0
      ) {
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#cart {
  width: 100%;
}

.cart-container {
  min-height: 590px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 5px;
  border-radius: 40px;
  padding: 25px;
}

.print-file-list {
  padding-top: 15px;
}

@media screen and (min-width: 620px) {
}
</style>
